// Facebook Pixel ID: 237002785703820 (index.html에서 이미 초기화됨)

// Facebook Pixel fbq 함수 타입
type FbqFunction = (
  action: string,
  eventName?: string,
  parameters?: Record<string, any>
) => void;

// index.html에서 스크립트가 로드되므로 바로 사용 가능
const fbq: FbqFunction | null =
  typeof window !== "undefined" && window.fbq
    ? (window.fbq as FbqFunction)
    : null;

// 편의 함수들
export const trackPageView = () => {
  if (fbq) {
    fbq("track", "PageView");
  }
};

// 표준 이벤트 추적 (Facebook이 미리 정의한 이벤트들: Purchase, CompleteRegistration 등)
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (fbq) {
    fbq("track", eventName, parameters);
  }
};

// 맞춤 이벤트 추적 (사용자가 직접 정의하는 이벤트)
export const trackCustomEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (fbq) {
    fbq("trackCustom", eventName, parameters);
  }
};

export default fbq;

